module.exports = __webpack_public_path__ + "img/DOGE-alt.d2121e09.svg";